import { Loader } from '@servicetitan/web-components';

export function App() {
    return <Loader src="https://unpkg.servicetitan.com/@servicetitan/routing-frontend@prod" />;
}
